import {DomainEvent} from './DomainEvent';
import {ProfileTransfer} from '../resources/ProfileTransfer';

export class ProfileTransferUpdated extends DomainEvent<ProfileTransfer> {}
